
import { useEffect, useRef, useState } from 'react';
import { useLenis } from '../../ScrollLenisProvider';

//MUI
import Grid from '@mui/material/Grid2';
import Box from '@mui/material/Box';
import Fab from '@mui/material/Fab';

// Icons
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';

//Our Imports
//Sections
import Intro from './components/StartIntro';
import Offers from './components/Offers';
import Benifits from './components/Benifits';
import Advantages from './components/Advantages';
import Help from './components/Help';
import Footer from '../../assets/component/footer';
import Calculator from './components/Calculator';
import AllInOne from './components/AllInOne';
import Counter from './components/Counter';


const Landing = () => {

	// from Provider
	const lenis = useLenis();

	//State
	const [reached, setReached] = useState(false);
	const [footerInView, setFooterInView] = useState(false);
	const showOnce = true;
	const [navTrigger, setNavTrigger] = useState('');
	
	//Ref
	const progressRef = useRef(null);
	const containerRef = useRef(null);
	const rafRef = useRef(null);
	const visibleRef = useRef(false);
	
	//Static Variables
	const radius = 21;
	const circumference = 2 * Math.PI * radius;
	
	//Effect

	useEffect(() => {
		if ('scrollRestoration' in window.history) {
			window.history.scrollRestoration = 'manual';
		}
		if (lenis) {
			lenis.scrollTo(0, { immediate: true });
		} else {
			window.scrollTo(0, 0);
		}
	}, [lenis]);

	useEffect(() => { //Back to top btn show
		if (!lenis) return;

		const update = () => {
			const scroll = lenis.animatedScroll;
			const limit = lenis.limit;
			if (!limit) {
				rafRef.current = requestAnimationFrame(update);
				return;
			}
			// calculate %
			const percent = scroll / limit;
			const dashOffset = circumference - percent * circumference;
			// only update stroke (NO REACT RENDER)
			if (progressRef.current) {
				progressRef.current.style.strokeDashoffset = dashOffset;
			}
			// show / hide button (without state)
			if (containerRef.current) {
				if (scroll > 600 && !visibleRef.current) {
					visibleRef.current = true;
					containerRef.current.style.opacity = 1;
					containerRef.current.style.transform = 'translateY(0px)';
				} else if (scroll <= 600 && visibleRef.current) {
					visibleRef.current = false;
					containerRef.current.style.opacity = 0;
					containerRef.current.style.transform = 'translateY(40px)';
				}
			}
			rafRef.current = requestAnimationFrame(update);
		};
		rafRef.current = requestAnimationFrame(update);
		return () => cancelAnimationFrame(rafRef.current);
	}, [lenis, circumference]);
	

	// --- Function --- //
	// Back to top 
	const goToTop = () => {
		if (!lenis) return;

		lenis.scrollTo(0, {
			immediate: true
			// duration: 3,
			// easing: (t) => 1 - Math.pow(1 - t, 4) // smooth easeOut
		});
	};

	const handleEnter = (proFrom) => {
		if (proFrom === 'enter') {
			setFooterInView(true);
		} else {
			setFooterInView(false);
		}
	};

	// const scrollToSection = (e, link) => {
	// 	e.preventDefault();

	// 	if (!lenis) return;

	// 	lenis.scrollTo(link, {
	// 		immediate: true
	// 	});
	// 	setShowOnce(false);
	// 	setTimeout(() => {
	// 		setShowOnce(true);
	// 	}, 3000);
	// };

	// const scrollToSection = (e, link) => {
	// 	e.preventDefault();
	// 	if (!lenis) return;

	// 	lenis.scrollTo(link, { immediate: true });

	// 	// trigger animation replay
	// 	setNavTrigger(link);
	// };

	const scrollToSection = (e, link) => {
		e.preventDefault();
		if (!lenis) return;

		const target = document.querySelector(link);
		if (!target) return;

		const rect = target.getBoundingClientRect();
		const scrollTop = window.scrollY || document.documentElement.scrollTop;

		// Absolute position of section
		const sectionTop = rect.top + scrollTop;

		// Center calculation
		const sectionHeight = rect.height;
		const viewportHeight = window.innerHeight;

		const centeredPosition = sectionTop - (viewportHeight / 2) + (sectionHeight / 2);

		lenis.scrollTo(centeredPosition, { immediate: true });

		setNavTrigger(link);
	};

	const sections = [
		{ comp: <Intro setReached={setReached} scrollToSection={scrollToSection} viewOnce={false}/> },
		{ comp: <Counter scrollToSection={scrollToSection} currentNav={navTrigger} setNavTrigger={setNavTrigger}/> },
		{ comp: <Offers viewOnce={showOnce}/> },
		{
			comp: <Calculator reached={navTrigger === '#demo' ? true : reached} viewOnce={showOnce}/>,
			style: { bgcolor: '#000000', overflow: 'hidden' },
			id: 'demo'
		},
		{ comp: <Benifits viewOnce={showOnce} navTrigger={navTrigger === '#benefits'}/>, id: 'benefits' },
		{ comp: <Advantages viewOnce={true} navTrigger={navTrigger === '#about'}/>, id: 'about' },
		{ comp: <Help viewOnce={showOnce}/>, class: 'helpSecBg', style: { overflow: 'hidden' } },
		{ comp: <AllInOne viewOnce={showOnce} scrollToSection={scrollToSection}/> }
	];

	return(
		<Box sx={{ position: 'relative', bgcolor: '#fbfaf8' }}>
			<Grid container spacing={3} sx={{ bgcolor: '#fbfaf8', zIndex: 50, position: 'relative' }}>
				{sections.map((sec, secIndex) => (
					<Grid size={12} key={secIndex} id={sec.id || ''} py={{ md: 4, xs: 2 }} sx={sec.style || {}} className={sec.class || ''}>
						{sec.comp}
					</Grid>
				))}
				<Grid size={12} className='section9Bg' sx={{ height: '100vh', zIndex: 5 }}></Grid>
			</Grid>
			<Grid size={12} id='contact' sx={{ bgcolor: '#242424', height: '100vh' }} onMouseEnter={() => handleEnter('enter')} onMouseLeave={() => handleEnter('')}>
				<Box sx={{ position: { lg: 'fixed', md: 'relative', sm: 'relative', xs: 'relative' }, bottom: 0, zIndex: 0, width: '100%' }}><Footer navTrigger={navTrigger === '#contact'} footerInView={footerInView}/></Box>
			</Grid>
			<Box
				ref={containerRef}
				sx={{
					position: 'fixed',
					bottom: '5%',
					right: '1%',
					zIndex: 1000,
					opacity: 0,
					transform: 'translateY(40px)',
					transition: 'all .35s cubic-bezier(.22,1,.36,1)'
				}}
			>
				<Box sx={{ position: 'relative', width: 60, height: 60 }}>
					{/* SVG Progress Ring */}
					<svg width='60' height='60' style={{ position: 'absolute', top: 0, left: 0, transform: 'rotate(-90deg)' }}>
						<circle
							cx='30'
							cy='30'
							r={radius}
							stroke='rgba(0,0,0,0.18)'
							strokeWidth='3'
							fill='none'
						/>
						<circle
							ref={progressRef}
							cx='30'
							cy='30'
							r={radius}
							stroke='#5B31A1'
							strokeWidth='3'
							fill='none'
							strokeDasharray={circumference}
							strokeDashoffset={circumference}
							style={{
								transition: 'stroke-dashoffset 0.05s linear',
								willChange: 'stroke-dashoffset'
							}}
						/>
					</svg>
					<Fab
						onClick={goToTop}
						size='small'
						sx={{
							position: 'absolute',
							inset: 0,
							margin: 'auto',
							width: 40,
							height: 40,
							minHeight: 40,
							background: '#fff',
							boxShadow: '0 10px 30px rgba(0,0,0,.25)'
						}}
					>
						<ArrowUpwardIcon className='font25 primaryCl'/>
					</Fab>
				</Box>
			</Box>
		</Box>
	);
};

export default Landing;
